module.exports = __webpack_public_path__ + "img/LRCX.OQ.0c543d19.png";